const translations = {
  "en": {
    "Continue chatting": "Continue chatting",
    "Something went wrong. Please check if the link is correct.": "Something went wrong. Please check if the link is correct."
  },
  "zh-tw": {
    "Continue chatting": "繼續聊天",
    "Something went wrong. Please check if the link is correct.": "好像出錯了，請檢查連結是否正確。"
  }
};

export default translations;
